/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-01 18:08:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:09:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/CollapseGroupContainer/index.tsx
 */
import React from 'react';

import { useSelector } from 'react-redux';
//import Node from '../Node';
import Element from 'src/layout/EditorPageLayout/Element/Elements';

const groupGenerate = ({
  salesChannelUuid,
  userPermissions,
  Node,
  getOrder,
}) => {
  const order: any = useSelector(getOrder());

  const arr = (order || []).map((i) => {
    const id = i.join('+');
    const body = (props) => collapseGroup({ idArr: i, props, Node });

    return { element: body, id, p: { salesChannelUuid, userPermissions } };
  });

  return arr;
};
const collapseGroup = ({ idArr, props = {}, Node }) => {
  const body = idArr.map((i) => {
    return <Node uuid={i} key={i} {...props} />;
  });
  return <Element>{body}</Element>;
};
export { groupGenerate };
